import { render, staticRenderFns } from "./StudentPausedCourses.vue?vue&type=template&id=c8bd0356&scoped=true"
import script from "./StudentPausedCourses.vue?vue&type=script&lang=ts"
export * from "./StudentPausedCourses.vue?vue&type=script&lang=ts"
import style0 from "./StudentPausedCourses.vue?vue&type=style&index=0&id=c8bd0356&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8bd0356",
  null
  
)

export default component.exports